import {createSvgIcon} from "@mui/material";
import React from "react";

const AndroidIcon = createSvgIcon(
    <svg
        fill="currentColor"
        viewBox="0 0 16 16"
        height="1em"
        width="1em"
    >
        <path d="M2.76 3.061a.5.5 0 01.679.2l1.283 2.352A8.94 8.94 0 018 5a8.94 8.94 0 013.278.613l1.283-2.352a.5.5 0 11.878.478l-1.252 2.295C14.475 7.266 16 9.477 16 12H0c0-2.523 1.525-4.734 3.813-5.966L2.56 3.74a.5.5 0 01.2-.678zM5 10a1 1 0 100-2 1 1 0 000 2zm6 0a1 1 0 100-2 1 1 0 000 2z" />
    </svg>,
"Android"
)

export default AndroidIcon;

